import React from 'react';
import { Navigation } from './Navigation.tsx';
import { Footer } from './Footer.tsx';
import classNames from 'classnames';

interface LayoutWrapperProps {
  children: React.ReactNode;
  hasHero?: boolean;
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  hasHero,
}) => {
  return (
    <div className='flex flex-col min-h-screen bg-gray-50'>
      <header className='bg-white shadow-sm'>
        <Navigation theme='dark' />
      </header>
      <main
        className={classNames({
          'px-4 py-8 container flex-grow mx-auto': !hasHero,
        })}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};
